import { CreateWaitlistEntryDTO, WaitlistEntryDTO } from './DTOs/WaitlistEntryDTO'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'

@Injectable({
    providedIn: 'root',
})
export class WaitlistService {

    private baseURL = environment.apiBaseUrl

    constructor(private http: HttpClient) { }

    createWaitlistEntry(
        organisationId: string,
        businessId: string,
        venueId: string,
        entry: CreateWaitlistEntryDTO,
    ): Observable<WaitlistEntryDTO> {
        const path =
            `/booking` +
            `/organisation/${encodeURIComponent(organisationId)}` +
            `/business/${encodeURIComponent(businessId)}` +
            `/venue/${encodeURIComponent(venueId)}` +
            `/waitlist`
        const url = new URL(path, this.baseURL)
        return this.http.post<WaitlistEntryDTO>(url.toString(), entry)
    }

    getWaitlistEntry(entryId: string): Observable<WaitlistEntryDTO> {
        const path = `/booking/waitlist/${encodeURIComponent(entryId)}`
        const url = new URL(path, this.baseURL)
        return this.http.get<WaitlistEntryDTO>(url.toString())
    }
}
